import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import {getUUID3Impl, getUUID5Impl, getUUIDImpl, validateV4UUID} from "./foreign.js";
const toString = v => v;
const showUUID = {show: v => "(UUID " + v + ")"};
const parseUUID = str => {
  if (validateV4UUID(str)) { return Data$dMaybe.$Maybe("Just", str); }
  return Data$dMaybe.Nothing;
};
const genv5UUID = s => v => getUUID5Impl(s)(v);
const genv3UUID = s => v => getUUID3Impl(s)(v);
const genUUID = getUUIDImpl;
const eqUUID = {eq: x => y => x === y};
const ordUUID = {compare: x => y => Data$dOrd.ordString.compare(x)(y), Eq0: () => eqUUID};
const emptyUUID = "00000000-0000-0000-0000-000000000000";
export {emptyUUID, eqUUID, genUUID, genv3UUID, genv5UUID, ordUUID, parseUUID, showUUID, toString};
export * from "./foreign.js";
